import Lottie from "react-lottie-player";
import firework from "./firework.json";

export const MyLottieAnimation = (props) => {
  return <Lottie animationData={firework} {...props} play />;
};
